import Vue from "vue";
import VueMeta from "vue-meta";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import design from "./assets/styles/glob.css";
import axios from "axios";
import VueAxios from "vue-axios";
import Clipboard from "v-clipboard";
import VueAnalytics from "vue-analytics";
Vue.use(VueAnalytics, {
  id: "UA-195891015-1",
  router,
  // debug: {
  //   enabled: true
  // }
});

Vue.config.productionTip = false;
Vue.config.silent = true;
Vue.use(VueAxios, axios);
Vue.use(design);
Vue.use(VueMeta);
Vue.use(Clipboard);

Vue.filter("separator", function(value) {
  if (value || value == 0) {
    let val = value / 1;
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return "";
  }
});

Vue.filter("persian", function(value) {
  if (value || value == 0) {
    if (typeof value !== "string") value = value.toString();

    value = value.split("0").join("۰");
    value = value.split("1").join("۱");
    value = value.split("2").join("۲");
    value = value.split("3").join("۳");
    value = value.split("4").join("۴");
    value = value.split("5").join("۵");
    value = value.split("6").join("۶");
    value = value.split("7").join("۷");
    value = value.split("8").join("۸");
    value = value.split("9").join("۹");
    return value;
  } else {
    return "";
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
